export * from "./DoctorsMap";
